import { numberWithCommas } from "../../utils";
import {
  PalletBranchRow,
  PalletBranchSummary,
} from "../../types/pallet-summary.type";
import PalletTable, { PalletColumn, detailColumn } from "./PalletTable";
import { branchLabel } from "./palletSummary";

const LEAD_COLUMNS: PalletColumn<PalletBranchRow>[] = [
  { label: "สาขา", render: branchLabel },
  {
    label: "จำนวนสายส่ง",
    align: "right",
    render: (branch) => numberWithCommas(branch.route_count),
  },
];

const branchKey = (branch: PalletBranchRow) => branch.branch_code;

interface BranchTableProps {
  report: PalletBranchSummary;
  onOpenBranch: (branchCode: string) => void;
}

/** ภาพรวมทุกสาขา — one row per branch with a trip in the range. */
export default function BranchTable({
  report,
  onOpenBranch,
}: Readonly<BranchTableProps>) {
  const openBranch = (branch: PalletBranchRow) => onOpenBranch(branch.branch_code);
  const trailingColumns = [detailColumn(openBranch)];

  return (
    <PalletTable
      leadColumns={LEAD_COLUMNS}
      trailingColumns={trailingColumns}
      rows={report.rows}
      rowKey={branchKey}
      totals={report.summary}
    />
  );
}
